import { cn } from "@/lib/utils";

interface PageLoaderProps {
	message?: string;
	className?: string;
}

export function PageLoader({
	message = "Loading...",
	className,
}: PageLoaderProps) {
	return (
		<div
			className={cn(
				"fixed inset-0 flex flex-col items-center justify-center bg-white z-50",
				className,
			)}
		>
			<div className="flex flex-col items-center gap-6">
				{/* Spinner */}
				<div className="relative">
					<div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-amber-500" />
				</div>

				{/* Message */}
				<p className="text-sm text-gray-500 animate-pulse">{message}</p>
			</div>
		</div>
	);
}
